import AppError from 'errors/app-error'

export default class MethodNotAllowedError extends AppError {
  constructor(method?) {
    super()
    this.statusCode = 405
    this.message = `Method ${method} Not Allowed`
  }
}
